import { OrganizationStatus } from 'api/data/user/types';

const isKYCd = (organizationStatus?: OrganizationStatus) =>
  ['VERIFIED', 'RESTRICTED'].includes(organizationStatus || '');

export default isKYCd;
